var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.94,
    y1: 5.49,
    x2: 3.72,
    y2: 5.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.06,
    y1: 19.74,
    x2: 17.06,
    y2: 17.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 5.49,
    width: 15.56,
    height: 16.47,
    rx: 1.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.28,17.51V5a1.75,1.75,0,0,0-1.74-1.74H5.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.69,1H19.76A1.75,1.75,0,0,1,21.5,2.78v13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages01);
export default __webpack_public_path__ + "static/media/Pages_01.1772c5a3c5218d2b168ebc33f8f52283.svg";
export { ForwardRef as ReactComponent };